import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import EOYReportAssistantPanel from "../components/EOYReportAssistant/EOYReportAssistantPanel";
import { whoami, getEntityTags } from "../services/APIClient";
import useReportingConfiguration from "../hooks/useReportingConfiguration";
import { TEACHER_DASHBOARD_NAVIGATION_IDS } from "../config/teacherDashboardNavigation";

/**
 * EOY Report Assistant page.
 * Thin wrapper — matches the convention of Chatbot.js.
 * All real logic lives in components/EOYReportAssistant/.
 */
function EOYReportAssistant() {
  const reportingConfiguration = useReportingConfiguration();
  const pageCopy =
    reportingConfiguration[TEACHER_DASHBOARD_NAVIGATION_IDS.EOY_REPORT_ASSISTANT];
  const [teacherName, setTeacherName] = useState("");
  const [teacherId, setTeacherId] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [isAuthorised, setIsAuthorised] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    whoami()
      .then((res) => {
        const user = res?.data || res;
        if (user?.stakeholder) {
          setTeacherName(user.stakeholder.name || "");
          setTeacherId(user.stakeholder.id);
          setSchoolId(user.stakeholder.schoolid);
          return getEntityTags("teacher", user.stakeholder.id);
        }
      })
      .then((tags) => {
        if (tags) {
          const tag = tags.find(
            (t) => t.tag_definition?.tag_name === "chatbot_teacher_access"
          );
          setIsAuthorised(tag?.tag_value === "ON");
        }
      })
      .catch((err) => console.error("EOYReportAssistant init failed:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Container fluid>
      <HeadingBanner
        name={teacherName ? `Welcome ${teacherName}!` : "EOY Report Assistant"}
        isLoggedIn={true}
        cloud={true}
        teacherid={teacherId}
      />
      <Row className="vh-100">
        <LeftPanel />
        <Col
          sm={{ span: 10, offset: 2 }}
          className="eoy-page-bg"
          style={{ paddingTop: "3%" }}
        >
          {!loading && (
            isAuthorised
              ? <EOYReportAssistantPanel
                  teacherId={teacherId}
                  schoolId={schoolId}
                  displayName={pageCopy.title}
                  displaySubheading={pageCopy.subheading}
                />
              : (
                <div style={{ textAlign: "center", marginTop: "10%", color: "#666" }}>
                  <h3>Access Restricted</h3>
                  <p>You do not have permission to access this feature.</p>
                </div>
              )
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default EOYReportAssistant;
